<template>
    <div class="booker-final">
        <div class="all-set">
            <p class="title">All set!</p>
            <p class="desc">
                Your booking profile is set up, you can start booking artists, organizing
                events and apply to opportunities.
            </p>
        </div>
        <div class="get-started">
            <p class="title">Get Started</p>
            <p class="desc">
                Now you can start planning an event by creating an opportunity for artists to
                apply to or you can make an offer to opportunities you feel you are a good fit
                for.
            </p>
            <div class="ctas">
                <button @click="() => redirect('/booking-manager')" class="create-opportunity">
                    Create an Opportunity
                </button>
                <button @click="() => redirect('/opportunities')" class="make-offer">
                    Make an Offer
                </button>
            </div>
        </div>
        <div class="discover-artists">
            <p class="title">Discover Artists</p>
            <div class="artists">
                <Artist
                    v-for="(user, indx) in artists"
                    :key="indx"
                    :artist="user"
                    :cta="'Invite'"
                    :show-cta="false"
                    :max-width="'232px'"
                    :selectable="false"
                    :redirect="true"
                    class="artist"
                />
                <div class="more-artists">
                    <p class="desc">Hundreds of artists ready to rock your event</p>
                    <button @click="() => redirect('/search')" class="more-artists-btn">
                        See all
                    </button>
                </div>
            </div>
        </div>
        <div class="explore-opportunities">
            <p class="title">Explore Opportunities</p>
            <div class="opportunities">
                <OpportunityCard
                    v-for="(opportunity, indx) in opportunities"
                    :key="indx"
                    :show-cta="false"
                    :event="opportunity"
                />

                <div class="more-opportunities">
                    <p class="desc">
                        There are tons of stages where you can dazzle audiences wanting more
                    </p>
                    <button
                        @click="() => redirect('/opportunities')"
                        class="more-opportunities-btn"
                    >
                        See all
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { api } from '@/helpers/api'
    import Artist from '@/components/search-result-artist/Artist.vue'
    import OpportunityCard from '@/components/ui/cards/OpportunityCard.vue'

    export default {
        name: 'BookerFinal',
        components: {
            Artist,
            OpportunityCard
        },
        data: () => ({
            load: false,
            artists: [],
            opportunities: []
        }),
        computed: {
            eventVibes: () => (event) => {
                let keywords

                if (event.array_keywords.length > 3) {
                    keywords = event.array_keywords.slice(0, 3).join(', ')

                    keywords = `${keywords} and ${event.array_keywords.length - 3} more...`
                } else {
                    keywords = event.array_keywords.join(', ')
                }

                return keywords
            },

            eventImage: (self) => (event) => {
                if (event.image && !event.image.includes('/global/default.png')) {
                    return event.image
                } else if (
                    event.venue.venue_info.main_avatar.includes('/global/default.png')
                ) {
                    return self.URLS.images.defaultEventImage
                } else {
                    return event.venue.venue_info.main_avatar
                }
            }
        },
        methods: {
            redirect(path) {
                window.location.href = path
            },
            async fetchArtists() {
                try {
                    this.load = true
                    const data = await api({
                        method: 'get',
                        url: '/api/search/artists?location=&city=&lat=&lon=&search=&date='
                    })

                    this.artists = data.data.result[0].artists.slice(0, 5)
                } finally {
                    this.load = false
                }
            },
            async fetchOpportunities() {
                try {
                    this.load = true
                    const data = await api({
                        method: 'get',
                        url: '/api/events/new-and-proceed-list-guest'
                    })
                    this.opportunities = data.bids.slice(0, 5)
                } finally {
                    this.load = false
                }
            },
            handleModalClose() {
                this.$emit('update:show-modal', false)
                window.location.href = '/booking-manager'
            }
        },
        async mounted() {
            await this.fetchArtists()
            await this.fetchOpportunities()

            const closeButton = document.querySelector('.modal-close-btn')
            if (closeButton) {
                closeButton.addEventListener('click', this.handleModalClose)
            }
        },
        beforeUnmount() {
            const closeButton = document.querySelector('.modal-close-btn')
            if (closeButton) {
                closeButton.removeEventListener('click', this.handleModalClose)
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .booker-final {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        gap: 24px;

        .all-set,
        .get-started,
        .discover-artists,
        .explore-opportunities {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            gap: 8px;

            .title {
                color: #dedede;
                @include base-font-20;
                font-weight: 600;
                line-height: 24px;
            }
            .desc {
                color: #8b8b8b;
                @include base-font-14;
                font-weight: 400;
            }
        }

        .get-started {
            padding: 16px;
            border-radius: 22px;
            border: 1px solid #333;
            background: #262626;

            .ctas {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                gap: 8px;

                button {
                    padding: 8px 12px;
                    border-radius: 120px;
                    background: #cdeb09;
                    color: #262626;
                    @include base-font-14;
                    line-height: 115%;
                    letter-spacing: 0.14px;
                }
            }
        }

        .discover-artists,
        .explore-opportunities {
            .artists::-webkit-scrollbar,
            .opportunities::-webkit-scrollbar {
                display: none;
            }
            .artists,
            .opportunities {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: stretch;
                gap: 8px;
                flex-wrap: nowrap;
                overflow-x: auto;
                -ms-overflow-style: none; /* Internet Explorer 10+ */
                scrollbar-width: none; /* Firefox */

                .more-artists,
                .more-opportunities {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                    max-width: 232px;
                    border-radius: 22px;
                    border: 1px solid #8b8b8b;
                    width: 100%;
                    flex-shrink: 0;
                    padding: 16px;

                    .desc {
                        color: #dedede;
                        @include base-font-20;
                        line-height: 24px;
                        text-wrap: wrap;
                    }

                    .more-artists-btn,
                    .more-opportunities-btn {
                        background: #cdeb09;
                        color: black;
                        padding: 10px 16px;
                        border-radius: 120px;
                        @include base-font-14;
                        line-height: 115%;
                        letter-spacing: 0.14px;
                        align-self: flex-end;
                    }
                }
            }
        }
    }
</style>
